import { API_V2 } from './apiVersion';

export const SSE_ENDPOINTS = {
  SUBSCRIBE: `${API_V2}/sse/subscribe`,

  ADMIN: {
    PUBLISH: `${API_V2}/admin/sse/publish`,
  },
} as const;
